/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { queryFormEditable, State } from '@gh/common-shared';
import { map$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import { PbDetailsState, querySelectedCostCenterId } from '../pb-details.state';

@Component({
  standalone: false,
  selector: 'gh-pb-items-components',
  templateUrl: 'pb-items-components.component.html',
  styleUrls: ['pb-items-components.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PbItemsComponentsComponent implements OnInit {
  editable: boolean = true;
  ccSelected$: Observable<boolean>;

  constructor(private state: State<PbDetailsState>) {
  }

  ngOnInit(): void {
    this.editable = this.state.project(queryFormEditable);
    this.ccSelected$ = this.state.select(querySelectedCostCenterId).pipe(map$(Boolean));
  }
}
